import { render, staticRenderFns } from "./POSInvoice.vue?vue&type=template&id=60087cc8&scoped=true"
import script from "./POSInvoice.vue?vue&type=script&lang=js"
export * from "./POSInvoice.vue?vue&type=script&lang=js"
import style0 from "./POSInvoice.vue?vue&type=style&index=0&id=60087cc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60087cc8",
  null
  
)

export default component.exports